import * as React from 'react'
import { Props }  from './types'

import './styles.scss'

/**
 * @description
 * @author Jonathan IBOR
 * @export
 * @class CircleButton
 * @extends {React.Component<Props>}
 */
export class CircleButton extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  render() {
    const {
      icon: Icon,
      onClick
    } = this.props

    return (
      <div
        className="circleButton"
        onClick={onClick}
      >
        {Icon}
      </div>
    )
  }
}